export type StaticPage = {
  slug: string;
  title: string;
  content: string;
  updatedAt: string | null;
};

type ApiStaticPage = {
  Slug: string;
  Title: string;
  Content: string;
  UpdatedAt?: string | null;
};

type ApiResponse<T> = T & {
  ok: boolean;
  message?: string;
};

async function parseJsonResponse<T>(response: Response): Promise<T> {
  const data = (await response.json().catch(() => ({}))) as ApiResponse<T>;
  if (!response.ok || data.ok === false) {
    throw new Error(data.message || "頁面載入失敗，請稍後再試。");
  }
  return data as T;
}

function normalizeItem(item: ApiStaticPage): StaticPage {
  return {
    slug: item.Slug,
    title: item.Title || "",
    content: item.Content || "",
    updatedAt: item.UpdatedAt || null,
  };
}

export async function fetchPublicStaticPage(slug: string): Promise<StaticPage | null> {
  try {
    const data = await fetch(`/api/pages/${encodeURIComponent(slug)}`, {
      credentials: "include",
      headers: { Accept: "application/json" },
    }).then((response) => parseJsonResponse<{ ok: boolean; Item: ApiStaticPage }>(response));
    return normalizeItem(data.Item);
  } catch {
    return null;
  }
}
